import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import {render} from 'react-dom'
import Router from './Router'

render(
  <Router/>,
  document.getElementById('root')
);